const _0 = "0deg"
const _1 = "1deg"
const _2 = "2deg"
const _3 = "3deg"
const _6 = "6deg"
const _12 = "12deg"
const config = { "0": _0, "1": _1, "2": _2, "3": _3, "6": _6, "12": _12,  }
export { config as default, _0, _1, _2, _3, _6, _12 }